import FormattedPolicyFrame, { POLICY_FRAME_LAYOUT } from './FormattedPolicyFrame'

export { POLICY_FRAME_LAYOUT }
export default FormattedPolicyFrame
